<template>
    <div class="mb-5">
        <DetailViewHeader
            :title="$t('Mapping')"
            :description="controller.model.getFile() ? controller.model.getFile().file_name : ''"
        >
            <template>
                <v-row>
                    <v-col>
                        <help-button link="importer_step2" />
                        <router-link :to="{ name: 'import_new', params: { account_id: controller.model.getCompanyId() }}" style="text-decoration: none">
                            <secondary-button>
                                {{ $t("Back") }}
                            </secondary-button>
                        </router-link>
                        <primary-button :loading="controller.model.getLoader().isLoading" @click="controller.nextStep()">
                            {{ $t("Next") }}
                        </primary-button>
                    </v-col>
                </v-row>
            </template>
        </DetailViewHeader>

        <ImporterSettingsViewOptions :controller="controller" />
        <ImporterSettingsViewFields :controller="controller" />
        <ImporterSettingsViewPreview :controller="controller" />
    </div>
</template>

<script>
import {onUnmounted, reactive} from "@vue/composition-api";
import { Router } from "@/composables/Router";
import DetailViewHeader from "../../../../components/DetailViewHeader";
import { CUSTOM_FIELD_RELATED_TYPE } from "@/helpers/constants";
import ImporterSettingsViewPreview from "@/views/Import/Xlsx/Settings/ImporterSettingsViewPreview";
import ImporterSettingsViewOptions from "@/views/Import/Xlsx/Settings/ImporterSettingsViewOptions";
import Controller from "./controller";
import ImporterSettingsViewFields from "@/views/Import/Xlsx/Settings/ImporterSettingsViewFields";

export default {
    name: "ImporterSettingsView",
    components: {
        DetailViewHeader,
        ImporterSettingsViewPreview,
        ImporterSettingsViewOptions,
        ImporterSettingsViewFields
    },
    setup() {
        const router = Router();

        const onWsMessage = (msg) => {
            if (msg) {
                router.push("/importer/{0}/import_result".format(msg.import_session_id));
            }
        }

        /** @type {Controller} */
        const controller = reactive(new Controller(onWsMessage, parseInt(router.currentRoute.params.id)))

        controller.loadData()

        onUnmounted(() => {
            controller.closeWebSocket()
        })

        return {
            CUSTOM_FIELD_RELATED_TYPE,
            /** @type {Controller} */
            controller
        };
    }
};
</script>
